import { api } from './api';

export const {
  useAuthorizeMutation,
  useChangePasswordMutation,
  useConfirmUserMutation,
  useCurrentUserQuery,
  useForgotPasswordMutation,
  useGetGRPDatesQuery,
  useGetQuotesQuery,
  useGetUsersQuery,
  useLazyCurrentUserQuery,
  useLazyGetUsersQuery,
  useLoginMutation,
  useRegisterUserMutation,
  useResendConfirmMutation,
  useResetPasswordMutation,
} = api;
